/**
 * Buddy's mark: the MoveBuddy mark cut from a turning matte pearl. See `pearlMark.module.css`.
 *
 * A component rather than a bare class, unlike `brandMark`, because the pearl is four masked layers
 * and every surface would otherwise repeat them. Two consumers: the conversation
 * (`features/ai-chat`) and the create window's „Nowy program z Buddym" start
 * (`features/create-plan`). Decorative everywhere: the words beside it name Buddy.
 */

import clsx from 'clsx';

import styles from './pearlMark.module.css';

/** At rest, while Buddy works, the one ember arrival, or standing still. */
export type PearlMarkState = 'rest' | 'work' | 'arrive' | 'still';

interface PearlMarkProps {
  readonly state?: PearlMarkState;
  /** The surface's size class: `width` and `height`. */
  readonly className?: string;
}

const STATE_CLASS: Readonly<Record<PearlMarkState, string | undefined>> = {
  rest: undefined,
  work: styles.work,
  arrive: styles.arrive,
  still: styles.still,
};

export function PearlMark({ state = 'rest', className }: PearlMarkProps) {
  return (
    <span className={clsx(styles.pearl, STATE_CLASS[state], className)} aria-hidden="true">
      <span className={clsx(styles.layer, styles.ghost)} />
      <span className={clsx(styles.layer, styles.ink)} />
      <span className={clsx(styles.layer, styles.arrival)} />
      <span className={clsx(styles.layer, styles.highlight)} />
    </span>
  );
}
